import React from 'react';
import styled from 'styled-components';
import openInNewTab from '../../../../../utils/openInNewTab';

type Props = {
  value: string;
  caption?: string
}
const UrlLink = ({ value, caption = undefined }) => {
  const onClick = () => {
    openInNewTab(value);
  };
  return <Wrapper title={value} onClick={onClick}>{caption || value}</Wrapper>;
};

export default UrlLink;

const Wrapper = styled.div`
  cursor: pointer;
  text-decoration: underline;
  color: var(--primary);
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
